import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { catchError, map, Observable, of, Subscription, switchMap, take } from 'rxjs';

import { EndPointService } from 'src/app/core/services/end-point.service';

import { StudentRoleSettings, UserLevelEnum } from 'src/app/auth/models/UserData';
import { AuthService } from 'src/app/auth/services/auth.service';
import {
  readCookie
} from 'src/app/shared/framework/cookies/Cookies';
import { ForgotLoginRequest, ForgotPasswordRequest, LoginFormModel, LoginFormResponseModel, ValidResetPasswordModel } from '../models/LoginForm';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private _userLoginUrl = '/PerfNav/logon/userlogin.asp';
  private _error: number;
  private _baseUrl = '/api/auth/';
  private setdefaultroleurl = 'setdefaultrole';
  private sendpasswordresetmail = 'sendpasswordresetmail';
  private _notloggedinurl = '/api/pagepublic/';
  private resetpassword = 'resetpassword';
  private validresetpassword = 'validresetpassword';
  private isloggedon = 'isloggedon';
  private sendloginforgotmail = 'sendloginforgotmail';
  private helpdeskmail = 'helpdesk';
  private showForgotPasswordUrl = '/api/login/showforgotpassword';
  private showForgotUserNameUrl = '/api/login/showforgotusername';
  private loginSubscr: Subscription;

  constructor(
    private _endPointService: EndPointService,
    private _router: Router,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private _authService: AuthService
  ) {
    this.registerEndPoints();
  }

  private registerEndPoints(): void {
    this._endPointService.registerEndPoint<boolean>(
      'isLoggedOn',
      `${this._notloggedinurl}${this.isloggedon}`,
      true
    );
    this._endPointService.registerEndPoint<LoginFormModel>(
      'postToUserLogin',
      `${this._userLoginUrl}`,
      true
    );
    this._endPointService.registerEndPoint<boolean>(
      'SetDefaultRole',
      `${this._baseUrl}${this.setdefaultroleurl}`,
      true
    );
    this._endPointService.registerEndPoint<ForgotPasswordRequest>(
      'sendPasswordResetMail',
      `${this._notloggedinurl}${this.sendpasswordresetmail}`,
      true
    );
    this._endPointService.registerEndPoint<ValidResetPasswordModel>(
      'resetPassword',
      `${this._notloggedinurl}${this.resetpassword}`,
      true
    );
    this._endPointService.registerEndPoint<ValidResetPasswordModel>(
      'validResetPassword',
      `${this._notloggedinurl}${this.validresetpassword}`,
      true
    );
    this._endPointService.registerEndPoint<ForgotLoginRequest>(
      'sendLoginForgotMail',
      `${this._notloggedinurl}${this.sendloginforgotmail}`,
      true
    );
    this._endPointService.registerEndPoint<any>(
      'helpdesk',
      `${this._notloggedinurl}${this.helpdeskmail}`,
      true
    );
    this._endPointService.registerEndPoint<string>(
      'ssolink',
      `/api/login/ssolink`,
      true
    );

    this._endPointService.registerEndPoint<boolean>(
      'ssologinenabled',
      `/api/login/ssologinenabled`,
      true
    );

    this._endPointService.registerEndPoint<boolean>(
      'showdisclaimer',
      '/api/auth/showdisclaimer',
      true
    );

    this._endPointService.registerEndPoint<string>(
      'getdisclaimer',
      '/api/pagepublic/getdisclaimer',
      true
    );
    this._endPointService.registerEndPoint<boolean>(
      'showforgotpassword',
      `${this.showForgotPasswordUrl}`,
      true
    );
    this._endPointService.registerEndPoint<boolean>(
      'showforgotusername',
      `${this.showForgotUserNameUrl}`,
      true
    );
  }

  public getError(): number {
    alert('2:' + this._error);
    return this._error;
  }

  /*public createCookie(name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = '; expires=' + date.toUTCString();
    } else var expires = '';
    document.cookie = name + '=' + value + expires + '; path=/';
  }

  public readCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  public eraseCookie(name) {
    this.createCookie(name, '', -1);
  }*/

  public sendPasswordResetMail(
    model: ForgotPasswordRequest
  ): Observable<number> {
    return this._endPointService.call<number>(
      'sendPasswordResetMail',
      model,
      true
    );
  }

  public sendLoginForgotMail(model: ForgotLoginRequest): Observable<number> {
    return this._endPointService.call<number>(
      'sendLoginForgotMail',
      model,
      true
    );
  }

  public resetPassword(model: ValidResetPasswordModel): Observable<number> {
    return this._endPointService.call<number>('resetPassword', model, true);
  }

  public isValidResetPasswordRequest(
    model: ValidResetPasswordModel
  ): Observable<boolean> {
    return this._endPointService.call<boolean>(
      'validResetPassword',
      model,
      true
    );
  }

  public postToUserLogin(model: LoginFormModel): any {
    localStorage.removeItem('manager_view');
    localStorage.removeItem('trainer_view');
    localStorage.removeItem('localhr_view');
    localStorage.removeItem('corporatehr_view');
    localStorage.removeItem('delegate_view');
    localStorage.removeItem('matrixmanager_view');
    localStorage.removeItem('delegate');
    localStorage.removeItem('Progreso.authorizationData');
    localStorage.removeItem('Progreso.authorizationExpires');
    localStorage.removeItem('Progreso.loginKey');
    localStorage.removeItem('Progreso.securityCode');
    localStorage.clear();

    if (this.loginSubscr) {
      this.loginSubscr.unsubscribe();
    }

    this.loginSubscr = this.http
      .post(this._userLoginUrl, this.JSON_to_URLEncoded(model), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'data-type': 'application/json',
        },
      })
      .subscribe((data: LoginFormResponseModel) => {
        let i = 0;

        if (data.gotohrexternroleselect === true) {
          window.top.location.href = '/Perfnav/logon/defaultexternandhr.asp';
        }

        if (data.err == 0) {
          if (data.gotochangepassword === true && data.role === 1) {
            let modelchangepassword: ForgotPasswordRequest = {
              username: model.username,
              role: 3,
            };
            this.sendPasswordResetMail(modelchangepassword);
            window.top.location.href = 'login?err=-1';
            return;
          } else {
            this.getSsoLoginEnabled().subscribe((ssologinEnabled) => {
              if (!ssologinEnabled) {
                this._router.navigate(['login'], { queryParams: {}, replaceUrl: true });
              }

              if (readCookie('LoginKey')) {
                localStorage.setItem(
                  'Progreso.loginKey',
                  readCookie('LoginKey')
                );
                //this.eraseCookie('LoginKey');
              }
              if (readCookie('securityCode')) {
                localStorage.setItem(
                  'Progreso.securityCode',
                  readCookie('securityCode')
                );
                //this.eraseCookie('securityCode');
              }

              if (data.twofactorauthentication) {
                this._router.navigate(['/2fa']);
              } else {
                if (!data.disclaimer) {

                  this._authService
                    .getUserRoles(true)
                    .subscribe((studentRoleSettings: StudentRoleSettings) => {
                      /*
                        Fix for bug, when they are not a manager but default role IS manager, we change it to matrix manager.
                      */
                      if (!studentRoleSettings.isManager && studentRoleSettings.isMatrixManager && data.defaultuserroleid == 33) {
                        data.defaultuserroleid = 333;
                      }

                      if (studentRoleSettings.isManager && studentRoleSettings.isMatrixManager && data.defaultuserroleid == 333) {
                        data.defaultuserroleid = 33;
                      }

                      switch (data.defaultuserroleid) {
                        case 0:
                          if (
                            studentRoleSettings.corporateHrId != null ||
                            studentRoleSettings.localHrId != null ||
                            studentRoleSettings.trainerId != null ||
                            studentRoleSettings.isManager === true ||
                            studentRoleSettings.isMatrixManager === true
                          ) {
                            this._router.navigate(['/roleselect']);
                          } else {
                            localStorage.setItem('corporatehr_view', '0');
                            localStorage.setItem('localhr_view', '0');
                            localStorage.setItem('trainer_view', '0');
                            localStorage.setItem('manager_view', '0');
                            localStorage.setItem('matrixmanager_view', '0');
                            window.top.location.href =
                              '/perfnav/student/ML/adm/V2contents.asp';
                          }
                          break;
                        case 3:
                          localStorage.setItem('corporatehr_view', '0');
                          localStorage.setItem('localhr_view', '0');
                          localStorage.setItem('trainer_view', '0');
                          localStorage.setItem('manager_view', '0');
                          localStorage.setItem('matrixmanager_view', '0');
                          window.top.location.href =
                            '/perfnav/student/ML/adm/V2contents.asp';
                          break;
                        case 33:
                          this._authService
                            .getUserRoles(true)
                            .subscribe((studentRoleSettings: StudentRoleSettings) => {
                              localStorage.setItem('corporatehr_view', '0');
                              localStorage.setItem('localhr_view', '0');
                              localStorage.setItem('trainer_view', '0');
                              localStorage.setItem('manager_view', '1');
                              localStorage.setItem('matrixmanager_view', '0');
                              window.top.location.href =
                                '/perfnav/student/ML/adm/V2contents.asp';
                            })
                          break;
                        case 6:
                          localStorage.setItem('corporatehr_view', '0');
                          localStorage.setItem('localhr_view', '0');
                          localStorage.setItem('trainer_view', '1');
                          localStorage.setItem('manager_view', '0');
                          localStorage.setItem('matrixmanager_view', '0');
                          this._authService.changeToTrainer();
                          break;
                        case 2:
                          localStorage.setItem('corporatehr_view', '0');
                          localStorage.setItem('localhr_view', '1');
                          localStorage.setItem('trainer_view', '0');
                          localStorage.setItem('manager_view', '0');
                          localStorage.setItem('matrixmanager_view', '0');
                          this._authService.changeToLocalHr();

                          break;
                        case 1:
                          localStorage.setItem('corporatehr_view', '1');
                          localStorage.setItem('localhr_view', '0');
                          localStorage.setItem('trainer_view', '0');
                          localStorage.setItem('manager_view', '0');
                          localStorage.setItem('matrixmanager_view', '0');
                          this._authService.changeToCorporateHr();

                          break;
                        case 333:
                          localStorage.setItem('corporatehr_view', '0');
                          localStorage.setItem('localhr_view', '0');
                          localStorage.setItem('trainer_view', '0');
                          localStorage.setItem('manager_view', '0');
                          localStorage.setItem('matrixmanager_view', '1');
                          this._authService.changeToMatrixManager();
                          break;
                      }
                    })
                } else {
                  window.top.location.href = '/perfnav/logon/disclaimer.asp';
                }
              }
            });
            this._error = 0;
          }
        } else {
          if (!data.counter) {
            window.top.location.href = 'login?err=' + data.err;
          } else {
            window.top.location.href = 'login?err=' + data.err + '&counter=' + data.counter;
          }
          /*let router:Router;
          router.
          this._error = data.err;
          alert("1:" + data.err);*/
        }

      });
  }

  private JSON_to_URLEncoded(element, key?, list?) {
    list = list || [];
    if (typeof element === 'object') {
      for (const idx in element) {
        this.JSON_to_URLEncoded(
          element[idx],
          key ? key + '[' + idx + ']' : idx,
          list
        );
      }
    } else {
      list.push(key + '=' + encodeURIComponent(element));
    }
    return list.join('&');
  }

  public setDefaultRole(roleid: number, fetch?: boolean): Observable<boolean> {
    return this._endPointService.call<boolean>('SetDefaultRole', roleid, fetch);
  }

  public setUserApplicationVersion(backendVersion: string): Observable<void> {
    return this.http.post<void>('/api/auth/setuserapplicationversion', { userVersion: backendVersion });
  }

  public getUserApplicationVersion(): Observable<string | null> {
    return this.http.get<{ userVersion: string }>('/api/auth/getuserapplicationversion').pipe(map(e => e?.userVersion));
  }

  public showDisclaimer() {
    return this._endPointService.call<boolean>('showdisclaimer', {}, true);
  }

  public getDisclaimer() {
    return this._endPointService.call<any>('getdisclaimer', {}, true).pipe(map(e => e.disclaimer));
  }

  public getHelpdeskEmail() {
    return this._endPointService.call<any>('helpdesk', {}, true).pipe(map(e => e.email));
  }

  public getSsoLoginEnabled() {
    return this._endPointService.call<boolean>('ssologinenabled', {}, true);
  }
  public getSsoLink() {
    return this._endPointService.call<any>('ssolink', {}, true).pipe(map(e => e.ssoLink));
  }

  public showForgotPassword() {
    return this._endPointService.call<boolean>('showforgotpassword', {}, true);
  }
  public showForgotUserName() {
    return this._endPointService.call<boolean>('showforgotusername', {}, true);
  }
}
